import reducers from 'redux/reducers';

export const setSecondDriverTypeAsDeleted = () => {
  reducers.drivers.update({secondTypeDriverIsDeleted: true});
};
